// extracted by mini-css-extract-plugin
export default {"hero":"Geschichte_hero__BJajZ","container":"Geschichte_container__GTcMS","section":"Geschichte_section__jJ+Zg","text":"Geschichte_text__JXwu0"};